import Button from '@components/formControls/Button'
import Box from '@mui/material/Box'
import Link from '@mui/material/Link'
import TableRow from '@mui/material/TableRow'
import { styled } from '@mui/material/styles'
import { colors } from '@theme/variables'

export const TableWrapper = styled(Box)`
  position: relative;
  width: 100%;
  margin-bottom: 5px;
`

export const StyledTableRow = styled(TableRow)`
  border-left: 1px solid ${colors.white};
  border-right: 1px solid ${colors.white};
  position: relative;

  ${(props: { isDisabled: boolean }) => `opacity: ${props.isDisabled ? '0.5' : '1'};`}

  &:hover {
    opacity: 1;
  }
`

export const StyledTableCell = styled(Box)`
  background-clip: padding-box;
  border: none;
  padding: 8px 13px;
  display: flex;
  align-items: center;
  ${(props: {
    $nowrap?: boolean
    $isNameCell?: boolean
    $cellWidth?: number
    $fixedWidth?: boolean
    $isDisabled: boolean
    $header: boolean
  }) => {
    let extraRules = ''
    if (props.$nowrap) {
      extraRules += 'white-space: nowrap; '
    }
    if (props.$cellWidth) {
      extraRules += `min-width: ${props.$cellWidth}px; `
    }
    if (props.$fixedWidth) {
      extraRules += `width: ${props.$cellWidth}px; `
      extraRules += `max-width: ${props.$cellWidth}px; `
    }
    if (props.$isDisabled) {
      extraRules += ' pointer-events: none;'
    }
    if (props.$header) {
      extraRules += ' border: none;'
    }

    return extraRules
  }};
`

export const StyledTableHeadCell = styled('div')`
  font-weight: 700;
  font-size: 15px;
`

export const TableCellInner = styled('div')`
  display: flex;
  align-items: center;
  color: ${colors.bodyText};
  background: ${colors.white};
`

export const ProfileCell = styled('div')`
  display: flex;
  align-items: center;
  gap: 16px;
`
export const ProfileCellInner = styled('div')``

export const ProfileCellTitle = styled(Link)`
  font-weight: 700;
  color: ${colors.black};
  text-decoration: none;
  font-size: 14px;
  word-break: break-all;
  font-weight: 700;
  cursor: pointer;
  pointer-events: ${({ $isDisabled }: { $isDisabled?: boolean }) => ($isDisabled ? 'none ' : 'auto')};

  &:hover {
    color: ${colors.primaryDark};
  }
`

export const ProfileCellCompanyName = styled('div')`
  font-weight: 700;
  color: ${colors.black};
  text-decoration: none;
  font-size: 12px;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 700;
`

export const ProfileCellSubtitle = styled('div')`
  font-weight: 700;
  color: ${colors.bodyText};
`

export const UpdatesCell = styled('div')`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`
export const UpdatesCellCropped = styled('div')`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  max-height: 67px;
  overflow: hidden;
`
export const UpdatesCellText = styled('div')`
  color: ${colors.bodyText};
  text-transform: lowercase;
  ${(props: { isLowercase: boolean }) => `text-transform: ${props.isLowercase ? 'lowercase' : 'initial'};`}
`
export const UpdatesCellMainText = styled('div')`
  color: ${colors.bodyText};
  font-weight: 600;
  ${(props: { isLowercase: boolean }) => `text-transform: ${props.isLowercase ? 'lowercase' : 'initial'};`}
`
export const UpdatesCellHighlightedText = styled(Link)`
  color: ${colors.primary};
  font-weight: 600;
  display: flex;
  text-decoration: none;

  ${(props: { isClickable: boolean }) => `cursor: ${props.isClickable ? 'pointer' : 'initial'};`}
`
export const UpdatedAtCell = styled('div')`
  font-weight: 700;
  color: ${colors.bodyText};
`
export const ReadCell = styled('div')`
  cursor: pointer;
`

export const EmptyUpdatesWrapper = styled('div')`
  width: 100%;
  height: 100%;

  flex: 1 1 auto;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`

export const EmptyUpdatesInner = styled('div')`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  max-width: 450px;
`

export const EmptyUpdatesPicture = styled('img')`
  width: 264px;
  height: 264px;
  margin-bottom: 16px;
`

export const EmptyUpdatesList = styled('ul')`
  align-self: flex-start;
  padding-left: 20px;
  margin-top: 2px;
`

export const EmptyUpdatesListItem = styled('li')``

export const EmptyUpdatesButton = styled(Button)`
  margin-bottom: 30px;

  padding: 12px 27px;
  height: 50px;
  border-radius: 58px;

  font-weight: 700;
  font-size: 20px;
  background-color: #3eabe3;
  color: ${colors.white};
`
